import { jsx as _jsx } from "react/jsx-runtime";
import i18next from 'i18next';
import { Button } from '@famly/mf_input_button';
import { DialogTestAttributes } from './dialog-test-attributes';
/**
 * The close button element to be used on modern famly dialogs.
 *
 * @param onClose callback called when the close button is clicked
 */
export const DialogCloseButton = ({ onClose }) => {
    return (_jsx(Button, { "data-e2e-id": DialogTestAttributes.xButtonE2eId, icon: "close", "aria-label": i18next.t($ => $.mf.modalsDialogs_dialog.src.translations.json.closeButtonAriaLabel), onClick: () => onClose(), variant: "transparent", flexShrink: 0, position: "relative", 
        // The title's top/bottom margins are uneven (24px vs 16px), so its text centre sits (24 - 16) / 2 = 4px
        // below the header row's centre. Nudge the X down 4px so it lines up with the title text's centre.
        top: "4px", 
        // Offset so the X's right edge lines up with the footer buttons' right edge (paddingX spacing(6) = 24px).
        // The regular icon button is a 48px circle with a 24px icon centred, leaving a 12px inset, so 24 - 12 = spacing(3).
        marginRight: 3 }));
};
